import { Injectable, EventEmitter } from '@angular/core';
import gql from 'graphql-tag';

import { Apollo } from 'apollo-angular';

@Injectable()
export class HistoricalTrendsService {
  constructor(private apollo: Apollo) {}

  getTable1Data(searchOpts) {
    /* parameters:
        $tableId=historical
        classifications ($class):
            1- Total United States
            2- Total nonfederal short-term general and other special
            3- Total community hospitals
            4- Nongovernment not-for-profit community hospitals
            5- Investor-owned (for-profit) community hospitals
            6- State and local government community hospital
        */
    const query = gql`
      query getTable1Data($tableId: String, $class: String, $startYear: String, $endYear: String) {
        getTable1Data(
          tableId: $tableId
          classification: $class
          startYear: $startYear
          endYear: $endYear
        ) {
          tableTitle
          tableDetails
          errors {
            tableId
            error
          }
          download {
            pdf
            excel
          }
          data {
            firstYear
            lastYear
            section {
              label
              subsection {
                label
                row {
                  cell {
                    year
                    value
                  }
                  label
                }
              }
              row {
                label
                cell {
                  year
                  value
                }
              }
            }
          }
        }
      }
    `;

    return this.apollo.watchQuery<any>({
      query: query,
      variables: searchOpts
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/t1-his-trends-utl/his-trends-util.services.ts